import { showPromptDialog, Checkbox } from '@bpinternal/ui-kit-next'

export const showBotDeletionPrompt = (botName: string): Promise<boolean | undefined> => {
  return showPromptDialog<boolean>(
    ({ value, setValue, setValid }) => (
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          This action cannot be undone. To confirm deletion, please check the box below:
        </p>
        <p className="text-sm font-medium">
          Bot name: <span className="rounded bg-muted px-1 py-0.5 font-mono">{botName}</span>
        </p>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="confirm-deletion"
            checked={value || false}
            onCheckedChange={(checked) => {
              setValue(checked as boolean)
              setValid(checked as boolean)
            }}
          />
          <label
            htmlFor="confirm-deletion"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            I understand that this action cannot be undone
          </label>
        </div>
      </div>
    ),
    {
      title: 'Delete bot',
      confirmLabel: `Delete bot`,
      cancelLabel: 'Cancel',
      variant: 'danger',
      size: 'max-w-2xl',
    }
  ).catch(() => undefined)
}
